<div>
  <div #dynamicLesson class="targetclass">
    <ng-template #target></ng-template>
  </div>
</div>

<br />
<div style="display: flex; gap: 10px">
  @if ((mainForm.controls | keyvalue)?.length) {
  <div>
    <p-button label="Calificar Lección" icon="pi pi-check-circle" (click)="evaluateForms()" [rounded]="true"></p-button>
  </div>
  }

  <p-button icon="pi pi-verified" [rounded]="true" (click)="startAI()" label="Repasar con IA" />
</div>
<br /><br />

@if(chatVisible()) {
<p-drawer header="Conversation" [visible]="chatVisible()" (visibleChange)="onVisibleChange($event)" position="bottom" styleClass="app-bottom-overlay">
  <dc-chat
    [backgroundTasks]="backgroundTasks"
    [conversationSettings]="conversationSettings()"
    (goalCompleted)="handleGoalCompleted($event)"
    (sendMessage)="onChatMessage($event)"></dc-chat>
</p-drawer>
}
